<span class="tile d-flex text-nowrap justify-content-center align-content-center p-1 tile">
  {{ tag }}
</span>